/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Available_FontsInputs */

const en_options_fonts_available_fonts = /** @type {(inputs: Options_Fonts_Available_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available Fonts`)
};

const fr_options_fonts_available_fonts = /** @type {(inputs: Options_Fonts_Available_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polices disponibles`)
};

const de_options_fonts_available_fonts = /** @type {(inputs: Options_Fonts_Available_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Schriftarten`)
};

const it_options_fonts_available_fonts = /** @type {(inputs: Options_Fonts_Available_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteri disponibili`)
};

const ru_options_fonts_available_fonts = /** @type {(inputs: Options_Fonts_Available_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступные шрифты`)
};

const es_options_fonts_available_fonts = /** @type {(inputs: Options_Fonts_Available_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuentes disponibles`)
};

const zh_cn2_options_fonts_available_fonts = /** @type {(inputs: Options_Fonts_Available_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用字体`)
};

const ja_options_fonts_available_fonts = /** @type {(inputs: Options_Fonts_Available_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能なフォント`)
};

const hi_options_fonts_available_fonts = /** @type {(inputs: Options_Fonts_Available_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्ध फ़ॉन्ट`)
};

const pt_pt2_options_fonts_available_fonts = /** @type {(inputs: Options_Fonts_Available_FontsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fontes disponíveis`)
};

/**
* | output |
* | --- |
* | "Available Fonts" |
*
* @param {Options_Fonts_Available_FontsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_available_fonts = /** @type {((inputs?: Options_Fonts_Available_FontsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Available_FontsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_fonts_available_fonts(inputs)
	if (locale === "de") return de_options_fonts_available_fonts(inputs)
	if (locale === "it") return it_options_fonts_available_fonts(inputs)
	if (locale === "ru") return ru_options_fonts_available_fonts(inputs)
	if (locale === "es") return es_options_fonts_available_fonts(inputs)
	if (locale === "zh-CN") return zh_cn2_options_fonts_available_fonts(inputs)
	if (locale === "ja") return ja_options_fonts_available_fonts(inputs)
	if (locale === "hi") return hi_options_fonts_available_fonts(inputs)
	if (locale === "pt-PT") return pt_pt2_options_fonts_available_fonts(inputs)
	return en_options_fonts_available_fonts(inputs)
});